// extracted by mini-css-extract-plugin
export default {"feedback":"Feedback_feedback__IJUOR","content":"Feedback_content__OOzP4","instructor":"Feedback_instructor__FXqev","contact":"Feedback_contact__WQMlH"};